import store from "@/store";

export function showLoadingScreen() {
    store.commit("setLoading", true);
}

export function hideLoadingScreen() {
    store.commit("setLoading", false);
}

export function changeChatWindowStatus(status) {
    store.commit("changeChatWindowStatus", status);
}

        